import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FullscreenService {
  readonly active = signal(false);

  constructor() {
    if (typeof document === 'undefined') {
      return;
    }

    document.addEventListener('fullscreenchange', () => {
      this.active.set(!!document.fullscreenElement);
    });
  }

  get isSupported(): boolean {
    return typeof document !== 'undefined' && document.fullscreenEnabled;
  }

  toggle(): void {
    if (!this.isSupported) {
      return;
    }

    if (document.fullscreenElement) {
      void document.exitFullscreen();
      return;
    }

    void document.documentElement.requestFullscreen();
  }
}
